import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    container: {
        gap: 0,
     
        css: css`
            &.grid-control {
                select[data-test-selector="paginationPerPageSelect"],
                select[data-test-selector="productListSortSelect"] {
                    color: ${themeColors.colorSelectBox} !important;
                    font-family: Roboto;
                    font-size: ${themeFontSizes.size14};
                    letter-spacing: .01rem;
                    line-height: 1.125rem;
                    border: 1px solid ${themeColors.colorBorderBrands} !important;
                    border-radius: 2px !important;
                    background-color: ${themeColors.colorWhite} !important;
                }
               > div {
                    justify-content: space-between;  
                }
                @media screen and (min-width: 1279px) {
                .control-second {
                    nav {
                        ul {
                            display: flex;
                            flex-wrap: nowrap;
                            align-items: center;
                        }
                    }
                }
            }
                .control-third {
                    flex-basis: 3%;
                    max-width:3%;
                }
            }
        `,
    },
    countGridItem: {
        width: [12, 12, 2, 5, 2],
    },
    countTableViewGridItem: {
        width: [12, 12, 12, 12, 2],
        css: css`
            @media screen and (max-width: 1279px) {
                width: 100%;
                flex-basis: 100%;
                max-width: 100%;
                font-style: italic;
                font-weight: 500;
            }
        `,
    },
    sortGridItem: {
        width: [12, 12, 5, 4, 6],
    },
    sortTableViewGridItem: {
        width: [12, 12, 5, 6, 6],
        css: css`
            @media screen and (max-width: 1279px) {
                width: 100%;
                flex-basis: 100%;
                max-width: 100%;
            }                
        `,
    },
    filterGridItem: {
        width: [0, 0, 0, 0, 1],
    },
    filterTableViewGridItem: {
        width: [0, 0, 1, 1, 1],
    },
    viewSelectGridItem: {
        width: [0, 0, 5, 3, 3],
        css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: none;                
                    `,
                css`
                    display: none;
                    `,
                null,
                null,
                null,
            ])}
        `,

    },
    viewSelectTableViewGridItem: {
        width: [0, 0, 4, 3, 3],
        css: css`
            @media screen and (max-width: 1279px) {
                position: absolute;
                top: 2rem;
                right: auto;
                left: 50%;
                max-width: 48%;
                display: inline-block;
                width: 50%;

                > div {
                    display: block;
                    min-width: 6.25rem;
                    max-width: 7.5rem;
                    > div {
                        justify-content: left;
                        display: block;

                        > div {
                            min-width: initial;
                        }
                    }
                }
                label {
                    display: block;
                    text-align: left;
                    padding-bottom: ${themeIndentSizes.indent5};
                }
            }
        `,
    },
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({ id, view }) => {
    return (
        <GridContainer {...styles.container} className="grid-control">
            <GridItem {...(view === "Table" ? styles.countTableViewGridItem : styles.countGridItem)} className="control-first">
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.sortTableViewGridItem : styles.sortGridItem)} className="control-second">
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.filterTableViewGridItem : styles.filterGridItem)} className="control-third">
                <Zone contentId={id} zoneName="Content02" />
            </GridItem>
            <GridItem {...(view === "Table" ? styles.viewSelectTableViewGridItem : styles.viewSelectGridItem)} className="control-last">
                <Zone contentId={id} zoneName="Content03" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: [ProductListPageContext],
    },
};

export default widgetModule;